import { Children, cloneElement, FC, ReactNode, useMemo } from "react";

import { Grid, useMediaQuery, } from "@mui/material";
import "./styles.scss"
import theme from "src/theme/light";

export type TActions = ReactNode[]

export interface IFiltersProps {
    actions: TActions;
    children: ReactNode;
}

const Filters: FC<IFiltersProps> = ({ actions, children }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const _renderActions = useMemo(() => {
        return Children.map(actions, (action: any, index: number) => {
            return cloneElement(action, { ...action.props })
        }
        )
    }, [actions]);

    return (
        <Grid container className={`Filters container data-grid`}>
            <Grid className="row-filters" container size="grow">
                <Grid className="row-filters" container size={12}>
                    {children}
                </Grid>
            </Grid>
            <Grid container className={`row-filters actions ${isMobile ? 'row-filters-mobile' : ''}`}  direction="row" justifyContent="flex-start" size="grow">
                {_renderActions}
            </Grid>
        </Grid>
    )
}

export { Filters };
